/**
 * Helper function for retrieving a property path
 * in string form (using the dot notation) from a given object.
 *
 * @param propertyPath - property path in string dot notation format
 * @param object - target object
 */
export const getNestedObjectPropertyValue = (
    propertyPath: string,
    object: Record<string, any>
) => {
    const pathSegments = propertyPath.split('.')
    const res = pathSegments.reduce((acc, curr, index) => {
        return acc === undefined
            ? index === pathSegments.length - 1
                ? undefined
                : {}
            : acc[curr]
    }, object) as any

    return res
}

/**
 * Helper function for setting a nested object property
 * gien a string of property path in dot notation format.
 *
 * @param propertyPath - property path in string do notation format
 * @param newValue - new value to set
 * @param object - target object
 *
 * @returns a new object with the updated property
 */
export const setNestedObjectPropertyValue = (
    propertyPath: string,
    newValue: any,
    object: Record<string, any>
) => {
    const pathSegments = propertyPath.split('.')
    const objectReplica = JSON.parse(JSON.stringify(object))
    let currentPropertyReference = objectReplica
    pathSegments.forEach((pathSegment: string, segmentIndex: number) => {
        if (segmentIndex === pathSegments.length - 1) {
            currentPropertyReference[pathSegment] = newValue
        } else {
            if (!currentPropertyReference[pathSegment])
                currentPropertyReference[pathSegment] = {}
            currentPropertyReference = currentPropertyReference[pathSegment]
        }
    })

    return objectReplica
}
